// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__35qqE","right":"styles_right__3TyNs"};